import { EClickPosition, EPageType } from 'shared/constant';
import { $SharingCurrentTraffic } from 'shared/atoms';
import { active } from '~/utils/active/active';
import { DeepLinkBuildingProps } from '~/utils/active/schema';
import { SHARING_DEFAULT_PID } from '~/utils/active';

export const activeToCurrentPage = (clickPosition: EClickPosition, clickId?: string): void => {
  const store = window.store;
  const traffic = store.get($SharingCurrentTraffic);
  let schemaOption: DeepLinkBuildingProps;

  switch (traffic.pageType) {
    case EPageType.USER:
      schemaOption = {
        pid: SHARING_DEFAULT_PID,
        pageType: 'user',
        userId: traffic.userId,
      };
      break;
    case EPageType.POI:
      schemaOption = {
        pid: SHARING_DEFAULT_PID,
        pageType: 'poi',
        poiId: traffic.poiId,
      };
      break;
    case EPageType.HASHTAG:
      schemaOption = {
        pid: SHARING_DEFAULT_PID,
        pageType: 'hashtag',
        hashtagId: traffic.hashtagId,
      };
      break;
    case EPageType.Gallery:
      schemaOption = {
        pid: SHARING_DEFAULT_PID,
        pageType: 'article',
        groupId: traffic.groupId,
        authorId: traffic.mediaId,
      };
      break;
    case EPageType.FIZZ:
      schemaOption = {
        pid: SHARING_DEFAULT_PID,
        pageType: 'fizz',
        groupId: traffic.groupId,
        authorId: traffic.mediaId,
      };
      break;
    case EPageType.VIDEO:
    default:
      schemaOption = {
        pid: SHARING_DEFAULT_PID,
        pageType: 'video',
        groupId: traffic.groupId,
        authorId: traffic.mediaId,
      };
      break;
  }

  active({
    schemaOption,
    ampExtraOption: {
      clickPosition,
      clickId,
    },
  });
};
